/**
 *  @class
 *  @function BrandsSwitcher
 */
if (!customElements.get('brands-switcher')) {

  const BRAND_SELECTION_STORAGE_KEY = 'BRAND_SELECTION_STORAGE_KEY';
  if (window.location.pathname.includes('books') || document.querySelector('[data-current-product-type="book"]')) {
    sessionStorage.setItem(BRAND_SELECTION_STORAGE_KEY, '"chickasaw-press"');
  }
  class BrandsSwitcher extends HTMLElement {
    constructor() {
      super();

      this.logoContainer = document.querySelector('.header .logo');
      this.headerMenuContainer = document.querySelector('.header .inline-header-nav');
      this.headerMenuMobileContainer = document.querySelector('#menu-disclosure');
      this.subheaderMenuOuter = document.querySelector('.subheader .subheader-menu');
      this.items = this.querySelectorAll('[data-brands-switcher-item]');
    }

    connectedCallback() {
      if (!this.items.length) {
        return;
      }
      
      this.getBrandSelection();
      if (!this.selectedBrand) { this.storeBrandSelection('default'); }
      this.configureSwitcher();
      this.configureHeaderLogo();
      this.configureHeaderMenu();
      this.configureSubheaderMenu();

      this.items.forEach((item) => {
        item.addEventListener('mousedown', this.onBrandSelect.bind(this)); 
      });
    }

    configureSwitcher() {
      if (!this.selectedBrand) return;

      const target = this.querySelector(`[data-brands-switcher-item="${this.selectedBrand}"]`);
      this.items.forEach((item) => { item.classList.remove('is-active'); })
      if (target) { target.classList.add('is-active'); }
    }

    configureHeaderLogo() {
      if (!this.selectedBrand || !this.logoContainer) return;

      fetch(`/?section_id=api-brands-logo`)
      .then((res) => res.text())
      .then((res) => {
        const fresh = document.createElement("div");
        fresh.innerHTML = res;

        this.logoContainer.innerHTML = fresh.querySelector(`[data-brands-logo-for="${this.selectedBrand}"]`).innerHTML;
      })
      .catch((err) => {
        console.log(err);
      })
    }

    configureHeaderMenu() {
      if (!this.selectedBrand) return;

      fetch(`/?section_id=api-brands-header-menu`)
        .then((res) => res.text())
        .then((res) => {
          const fresh = document.createElement("div");
          fresh.innerHTML = res;

          const desktopMenu = fresh.querySelector(`[data-brands-menu-for="${this.selectedBrand}"]`);
          const mobileMenu = fresh.querySelector(`[data-brands-mobile-menu-for="${this.selectedBrand}"]`);
          if (this.headerMenuContainer && desktopMenu) {
            this.headerMenuContainer.innerHTML = desktopMenu.querySelector(".inline-header-nav").innerHTML;
            this.headerMenuContainer.classList.remove("hidden");
          }
          if (this.headerMenuMobileContainer && mobileMenu) {
            this.headerMenuMobileContainer.innerHTML = mobileMenu.querySelector("#menu-disclosure").innerHTML;
            this.headerMenuMobileContainer.classList.remove("hidden");
          }
        })
        .catch((err) => {
          console.log(err);
        })
    }

    configureSubheaderMenu() {
      if (!this.selectedBrand || !this.subheaderMenuOuter) return;
      const subheaderMenuContainer = this.subheaderMenuOuter.querySelector('.inline-subheader-nav');

      fetch(`/?section_id=api-brands-subheader-menu`)
        .then((res) => res.text())
        .then((res) => {
          const fresh = document.createElement("div");
          fresh.innerHTML = res;

          const desktopMenu = fresh.querySelector(`[data-brands-menu-for="${this.selectedBrand}"]`);
          if (subheaderMenuContainer && desktopMenu) {
            subheaderMenuContainer.innerHTML = desktopMenu.querySelector(".inline-subheader-nav").innerHTML;
            this.subheaderMenuOuter.classList.remove("hidden");
          }
        })
        .catch((err) => {
          console.log(err);
        })
    }

    onBrandSelect(evt) {
      const target = evt.currentTarget;
      const id = target.getAttribute('data-brands-switcher-item');
      if (id) this.storeBrandSelection(id);
    }

    getBrandSelection() {
      const storedBrandSelection = sessionStorage.getItem(BRAND_SELECTION_STORAGE_KEY);
      this.selectedBrand = storedBrandSelection ? JSON.parse(storedBrandSelection) : null;
      if (window.location.pathname.includes('/pages/authors') || window.location.href.includes('chickasawpress') || document.querySelector('[data-chickasawpress-page="true"]')) {
        this.selectedBrand = "chickasaw-press";
      }
      console.log(this.selectedBrand,'this.selectedBrand')
    }

    storeBrandSelection(data) {
      const dataString = JSON.stringify(data);

      sessionStorage.setItem(BRAND_SELECTION_STORAGE_KEY, dataString);
      this.selectedBrand = data;
    }
  }
  customElements.define('brands-switcher', BrandsSwitcher);
}